import { Typography } from '@mui/material';

const Blockquote = (props) => (
  <Typography
    component="blockquote"
    sx={(theme) => ({
      borderLeft: '5px solid',
      borderColor: theme.palette.primary.main,
      lineHeight: '2rem',
      fontSize: '1.5rem',
      borderRadius: 1,
      my: 4,
      mx: 4,
      pl: 5,
      py: 3
    })}
    {...props}
  />
);

export default Blockquote;
